import React, { SyntheticEvent, useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PropsSnackbar } from './types';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={8} ref={ref} variant="filled" {...props} />;
});

export function CustomizedSnackbars() {
  const [contentSnackbar, setContentSnackbar] = useState<PropsSnackbar | null>();

  useEffect(() => {
    window.addEventListener('show-snackbar', displaySnackbar as EventListener);
    return () => {
      window.removeEventListener('show-snackbar', displaySnackbar as EventListener);
    };
  }, []);

  const displaySnackbar = (event: CustomEvent<PropsSnackbar>) => {
    setContentSnackbar(event.detail);
  };

  const handleClose = (_: Event | SyntheticEvent<unknown, Event>, reason?: string) => {
    if (reason === 'clickaway') return;

    setContentSnackbar(null);
  };

  if (!contentSnackbar) return null;

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        open={contentSnackbar?.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          variant="filled"
          onClose={handleClose}
          severity={contentSnackbar?.type}
          sx={contentSnackbar?.customSx}
          iconMapping={{
            success: <CheckCircleIcon />,
            error: <ErrorOutlinedIcon />,
          }}
        >
          {contentSnackbar.message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}

export default CustomizedSnackbars;
